var map = {
	"./arrow-down-circle.svg": "mqwo",
	"./arrow-down.svg": "Peom",
	"./arrow-up.svg": "P3Ow",
	"./awards.svg": "Mlpt",
	"./ck.svg": "UH9m",
	"./currency.svg": "Fq0o",
	"./hot.svg": "j1mB",
	"./icon-2-circle.svg": "pRHw",
	"./icon-3dbox.svg": "6WOt",
	"./icon-arrow-down-circle.svg": "Fkem",
	"./icon-cart.svg": "oxQ3",
	"./icon-case.svg": "SJnU",
	"./icon-checked-circle-green.svg": "qh5Z",
	"./icon-checked.svg": "zTO7",
	"./icon-collection.svg": "GV9i",
	"./icon-currency.svg": "t1oj",
	"./icon-dot-circle.svg": "M5tE",
	"./icon-fangdajing.svg": "e/WR",
	"./icon-fire.svg": "hin9",
	"./icon-home.svg": "bTi9",
	"./icon-link.svg": "sqHv",
	"./icon-location.svg": "9Lce",
	"./icon-lock.svg": "ct1T",
	"./icon-painspot.svg": "N3V0",
	"./icon-paper-plant.svg": "mh7v",
	"./icon-pointer.svg": "DGDc",
	"./icon-shiled-v.svg": "MlfX",
	"./icon-sjjc.svg": "El9o",
	"./icon-star.svg": "xQx7",
	"./icon-thumb.svg": "MZtb",
	"./icon-weixin.svg": "/2B3",
	"./magnifier.svg": "G4MR",
	"./mm.svg": "kdO5",
	"./paper-plant.svg": "4FWg",
	"./phone.svg": "7pRf",
	"./qq.svg": "R2jY",
	"./sjh.svg": "MmXq",
	"./vx.svg": "t4pt",
	"./warning.svg": "TcIt",
	"./yhm.svg": "czHC",
	"./yzm.svg": "1hRL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 71